var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthlatam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 10,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.329 1.318H0v7.363h1.329V5.666h4V4.348h-4v-3.03zM6.657 10H1.329V8.682h5.328V10zm0-8.682H1.329V0h5.328v1.318zM11.991 10h-1.328V1.318H7.991V0h6.671v1.318h-2.671V10zM22.653 0h1.329v10h-1.329V5.666h-5.328V10h-1.328V0h1.328v4.348h5.328V0zm9.09 0l-1.118 1.667L29.506 0h2.237z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.743 3.333l1.118-1.667h-2.237-2.237l1.119 1.667h-2.237L28.387 5l-1.118 1.667h2.237l-1.119 1.667h2.237L29.506 10h2.237l-1.118-1.667h2.237l-1.118-1.667h2.237L32.861 5l1.118-1.667h-2.237zm0 0l-1.118-1.667-1.118 1.667L28.387 5l1.119 1.667 1.118 1.667 1.118-1.667L32.861 5l-1.118-1.667zM29.332 5l1.281-1.937L31.894 5l-1.281 1.938L29.332 5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.653 8.684V10h-5.28V8.684h5.28zM37.056.014h1.317v8.669h-1.317V.014zm10.553 1.317V.014h2.633v1.317h-2.633zm0 1.317h-1.317V1.331h1.317v1.317zm5.266 0V10h-1.316V6.989h-5.266V10h-1.316V2.647h1.316v3.025h5.266V2.647h1.316zm-2.633 0V1.331h1.316v1.317h-1.316zM56.897 10h1.331V1.12h3.333V0h-7.997v1.12h3.333V10zm7.972-8.669V.014h2.633v1.317h-2.633zm0 1.317h-1.316V1.331h1.316v1.317zm5.266 0V10h-1.316V6.989h-5.266V10h-1.316V2.647h1.316v3.025h5.266V2.647h1.316zm-2.633 0V1.331h1.317v1.317h-1.317zM71.917 10h1.26V1.681h.028L76.329 10h1.135l3.123-8.319h.028V10h1.26V0h-1.821l-3.165 8.403L73.738 0h-1.821v10z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h81.875v10H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthlatam);
export default __webpack_public_path__ + "static/media/ethlatam.a2f272789dd52db596a63afbf4c31c04.svg";
export { ForwardRef as ReactComponent };